import isAndroidSamsung from 'services/isAndroidSamsung';
import isAppleComputerInc from 'services/isAppleComputerInc';
import getStore from 'services/getStore';
import { State } from 'store/store';

const store = getStore();
const isDevice = isAppleComputerInc() || isAndroidSamsung();

export const getModuleIsFreeScrollingDesktop = () => {
  const state = store.getState();

  const moduleIsFreeScrollingDesktop =
    state.theme?.moduleIsFreeScrolling?.desktop || false;

  return !isDevice && moduleIsFreeScrollingDesktop;
};

export const getModuleIsFreeScrollingDevice = () => {
  const state = store.getState();

  const moduleIsFreeScrollingDevice =
    state.theme?.moduleIsFreeScrolling?.device || false;

  return isDevice && moduleIsFreeScrollingDevice;
};
